export default {
  common: {
    close: '閉じる',
    unlocked: 'アンロック済み',
    confirm: '確認',
    cancel: 'キャンセル',
    all: 'すべて',
    locked: 'ロック中',
    clickToSelect: 'クリック'
  },

  game: {
    stats: {
      total: '合計',
      combo: 'コンボ',
      record: '記録',
      days: '日数'
    },
    currentType: '現在のタイプ',
    inUse: '使用中',
    autoTap: '自動タップ',
    on: 'オン',
    off: 'オフ',
    clickToChangeType: 'クリックして祈福タイプを変更',
    clickToChangeFish: 'クリックして木魚を変更',
    selectType: '祈福タイプを選択',
    selectTypeDesc: '異なるタイプを選択して異なる祝福効果を得る',
    typeTips: 'タイプのヒント',
    typeTip1: '異なるタイプには異なるパーティクル効果がある',
    typeTip2: 'タイプの切り替えはコンボと統計に影響しない',
    typeTip3: '各タイプのタップ数は個別に計算される'
  },

  brand: {
    tagline: '一打一念',
    company: 'Homy Tech Limited'
  },

  types: {
    merit: {
      name: '功徳',
      description: '功徳を積み、心を浄化する'
    },
    love: {
      name: '愛情',
      description: '良縁を祈り、感情を深める'
    },
    wealth: {
      name: '財運',
      description: '財を招き、富を増やす'
    },
    health: {
      name: '健康',
      description: '心身健康、長寿を願う'
    }
  },

  typeStats: {
    title: 'タップ統計',
    subtitle: '各タイプのタップ回数統計を表示',
    totalTaps: '総タップ回数',
    allTypes: 'すべてのタイプ合計',
    times: '回',
    description: 'タイプ合計',
    tips: {
      title: '統計のヒント',
      tip1: '異なるタイプを切り替えて異なる祈福効果を体験',
      tip2: '各タイプのタップをバランスよく行うと特別な実績を解除',
      tip3: '各タイプには専用のパーティクル効果とエネルギーがある'
    }
  },

  achievements: {
    title: '修行実績',
    subtitle: '修行の軌跡を記録',
    progress: '解除進行度',
    filterByCategory: 'カテゴリーで絞り込み',
    unlocksFish: '特別な木魚を解除',
    noResults: '該当する実績がありません',
    allAchievements: 'すべての実績',
    unlockedAchievements: '解除済み',
    lockedAchievements: 'ロック中',
    categories: {
      all: 'すべて',
      tap: 'タップ',
      combo: 'コンボ',
      speed: 'スピード',
      type: 'タイプ',
      auto: '自動',
      special: '特殊'
    },
    rarity: {
      common: '普通',
      uncommon: '非凡',
      rare: 'レア',
      epic: 'エピック',
      legendary: 'レジェンド',
      mythic: '神話'
    },
    tips: {
      title: '実績のヒント',
      tip1: '継続的にタップしてより多くの実績を解除',
      tip2: '異なるタップ方法を試して隠し実績を発見',
      tip3: '一部の実績は特別な木魚を解除',
      tip4: '実績の進行度は自動保存される'
    }
  },

  achievementsList: {
    first_tap: {
      title: '初入門',
      description: '初めて木魚をタップ'
    },
    tap_100: {
      title: '誠心正意',
      description: '累計100回タップ'
    },
    tap_500: {
      title: '勤修不輟',
      description: '累計500回タップ'
    },
    tap_1000: {
      title: '持之以恆',
      description: '累計1,000回タップ'
    },
    tap_5000: {
      title: '功徳円満',
      description: '累計5,000回タップ'
    },
    tap_10000: {
      title: '万法帰一',
      description: '累計10,000回タップ'
    },
    tap_50000: {
      title: '修行大師',
      description: '累計50,000回タップ'
    },
    tap_100000: {
      title: '不朽伝説',
      description: '累計100,000回タップ'
    },
    combo_10: {
      title: '初窺門径',
      description: '10コンボ達成'
    },
    combo_25: {
      title: '漸入佳境',
      description: '25コンボ達成'
    },
    combo_50: {
      title: '心無旁騖',
      description: '50コンボ達成'
    },
    combo_100: {
      title: '専注一致',
      description: '100コンボ達成'
    },
    combo_200: {
      title: '天人合一',
      description: '200コンボ達成'
    },
    combo_500: {
      title: '超凡入聖',
      description: '500コンボ達成'
    },
    combo_1000: {
      title: '永恒之撃',
      description: '1,000コンボ達成'
    },
    speed_5: {
      title: '迅捷之手',
      description: '0.5秒以内に連続タップ'
    },
    speed_3: {
      title: '快手如風',
      description: '0.2秒以内に連続タップ'
    },
    speed_1: {
      title: '閃電反射',
      description: '0.1秒以内に連続タップ'
    },
    perfect_rhythm: {
      title: '完璧なリズム',
      description: '連続10回、1〜2秒の完璧な間隔を保つ'
    },
    rhythm_master: {
      title: 'リズムマスター',
      description: '連続30回、1〜2秒の完璧な間隔を保つ'
    },
    type_master: {
      title: 'タイプマスター',
      description: '4種類の祈福タイプを各50回タップ'
    },
    merit_devotee: {
      title: '功徳虔誠者',
      description: '功徳モード累計500回'
    },
    love_seeker: {
      title: '愛情追尋者',
      description: '愛情モード累計500回'
    },
    wealth_collector: {
      title: '財運収集者',
      description: '財運モード累計500回'
    },
    health_guardian: {
      title: '健康守護者',
      description: '健康モード累計500回'
    },
    buddha: {
      title: '仏光普照',
      description: '功徳モード累計1,000回'
    },
    love_master: {
      title: '愛情大師',
      description: '愛情モード累計1,000回'
    },
    wealth_tycoon: {
      title: '財運大亨',
      description: '財運モード累計1,000回'
    },
    health_sage: {
      title: '健康聖者',
      description: '健康モード累計1,000回'
    },
    merit_legend: {
      title: '功徳伝説',
      description: '功徳モード累計2,000回'
    },
    love_legend: {
      title: '愛情伝説',
      description: '愛情モード累計2,000回'
    },
    wealth_legend: {
      title: '財運伝説',
      description: '財運モード累計2,000回'
    },
    health_legend: {
      title: '健康伝説',
      description: '健康モード累計2,000回'
    },
    balanced_monk: {
      title: 'バランス修行者',
      description: '4種類のタイプを各100回達成'
    },
    ultimate_devotion: {
      title: '至高奉献',
      description: '4種類のタイプを各500回達成'
    },
    auto_beginner: {
      title: '自動化初探',
      description: '自動タップ機能を有効化'
    },
    auto_100: {
      title: '機械助手',
      description: '自動タップ累計100回'
    },
    auto_1000: {
      title: '自動化大師',
      description: '自動タップ累計1,000回'
    },
    auto_5000: {
      title: '機械禅師',
      description: '自動タップ累計5,000回'
    },
    auto_lover: {
      title: '自動化愛好者',
      description: '自動タップを10回有効化'
    },
    lazy_master: {
      title: '放置大師',
      description: '自動タップ累計10,000回'
    },
    night_owl: {
      title: '夜猫子',
      description: '深夜0時〜6時に50回タップ'
    },
    early_bird: {
      title: '早起き鳥',
      description: '朝6時〜9時に50回タップ'
    },
    midnight_devotion: {
      title: '午夜虔誠',
      description: '深夜0時〜6時に200回タップ'
    },
    morning_blessing: {
      title: '朝曦祝福',
      description: '朝6時〜9時に200回タップ'
    },
    session_100: {
      title: '単次百撃',
      description: '1セッションで100回タップ'
    },
    session_500: {
      title: '単次狂熱',
      description: '1セッションで500回タップ'
    },
    session_1000: {
      title: '単次千撃',
      description: '1セッションで1,000回タップ'
    },
    marathon: {
      title: 'マラソン修行',
      description: '1セッションで2,000回タップ'
    },
    steady_hand: {
      title: '安定之手',
      description: '連続20回、0.8〜2秒の間隔でタップ'
    },
    metronome: {
      title: 'メトロノーム',
      description: '連続10回、0.1秒以内の誤差でタップ'
    },
    cat_lover: {
      title: '猫友',
      description: '累計2,000回タップ'
    },
    rainbow_master: {
      title: '七彩祥雲',
      description: '5種類の異なる木魚を解除'
    },
    cosmic_collector: {
      title: '宇宙真理',
      description: '10,000回タップ達成'
    },
    fish_collector: {
      title: '木魚収集家',
      description: 'すべての特別な木魚を解除'
    },
    achievement_hunter: {
      title: '実績ハンター',
      description: '20個の実績を解除'
    },
    completionist: {
      title: '完璧主義者',
      description: '40個の実績を解除'
    },
    true_master: {
      title: '真の大師',
      description: 'すべての実績を解除'
    }
  },

  specialFish: {
    title: '特別な木魚',
    subtitle: '特別な木魚を収集・使用',
    progress: '収集進行度',
    unlockCondition: '解除条件',
    howToUnlock: '解除方法',
    description: '特定の実績を達成すると特別な木魚を解除、それぞれユニークな外観',
    clickToSelect: '木魚を選択',
    clickToSelectDesc: '下記の解除済み木魚カードをクリックすると、その木魚に切り替えられます。選択された木魚には ✓ マークが表示されます。',
    types: {
      normal: {
        name: '普通の木魚',
        description: '基本的な木魚、幸運と平安をもたらす',
        unlock: 'デフォルトで解除済み'
      },
      golden: {
        name: '黄金の木魚',
        description: '富のオーラを放つ木魚、財運を増加',
        unlock: '功徳モード累計1,000回'
      },
      crystal: {
        name: '水晶の木魚',
        description: '透明な水晶の木魚、心を浄化',
        unlock: '100コンボ達成'
      },
      jade: {
        name: '翡翠の木魚',
        description: '平和と長寿を象徴する翡翠の木魚',
        unlock: '4種類の祈福タイプを各50回タップ'
      },
      ruby: {
        name: 'ルビーの木魚',
        description: '情熱に満ちたルビーの木魚、活力を増加',
        unlock: '0.2秒以内に連続タップ'
      },
      cat: {
        name: '猫の木魚',
        description: 'かわいい猫型の木魚、ニャーと鳴く',
        unlock: '累計2,000回タップ'
      },
      rainbow: {
        name: '虹の木魚',
        description: '華やかな虹の木魚、幸福感をもたらす',
        unlock: '5種類の異なる木魚を解除'
      },
      cosmic: {
        name: '宇宙の木魚',
        description: '無限の宇宙エネルギーを含む神秘的な木魚',
        unlock: '10,000回タップ達成'
      }
    }
  },

  help: {
    title: 'ゲーム説明',
    tabs: {
      gameplay: '遊び方',
      types: 'タイプ',
      fish: '木魚',
      achievements: '実績',
      tips: 'コツ'
    },
    gameplay: {
      step1: {
        title: '木魚をタップ',
        description: '中央の木魚をタップしてください'
      },
      step2: {
        title: 'エネルギーを蓄積',
        description: '各タップは対応するタイプのエネルギーを増加'
      },
      step3: {
        title: '連続タップ',
        description: '2秒以内に連続タップでコンボボーナス獲得'
      },
      step4: {
        title: '自動タップ',
        description: '自動タップ機能を有効にして自動でタップ'
      }
    },
    controls: {
      title: '操作方法',
      mouse: 'マウスクリック',
      touch: 'タッチスクリーン',
      keyboard: 'スペースキー'
    },
    fish: {
      description: '特定の実績を達成すると特別な木魚を解除',
      level: {
        common: '普通',
        rare: 'レア',
        epic: 'エピック',
        legendary: 'レジェンド'
      }
    },
    achievements: {
      description: '様々なチャレンジを達成して実績報酬を解除',
      achievements: '個の実績',
      rarity: 'レアリティレベル'
    },
    tips: {
      tip1: {
        title: 'リズムを保つ',
        description: '安定したタップリズムでより高いコンボを獲得'
      },
      tip2: {
        title: 'スピードを試す',
        description: '高速タップでスピード関連の実績を解除'
      },
      tip3: {
        title: '自動を活用',
        description: '自動タップは長時間の修行に適している'
      },
      tip4: {
        title: '木魚を収集',
        description: 'すべての特別な木魚を解除して追加報酬を獲得'
      },
      tip6: {
        title: 'タイプを切り替え',
        description: '異なるタイプを試して異なる祝福を獲得'
      }
    },
    shortcuts: {
      title: 'ショートカット',
      space: '木魚をタップ',
      esc: 'モーダルを閉じる'
    }
  },

  donation: {
    title: '支援',
    subtitle: 'あなたの支援が私たちの最大の原動力',
    message: 'このゲームが気に入ったら、より多くの面白い機能を開発するために支援をお願いします',
    oneTime: '一回限り',
    oneTimeDesc: '一度の支援',
    monthly: '毎月',
    monthlyDesc: '継続的な支援',
    selectAmount: '金額を選択',
    perMonth: '毎月',
    donateButton: '支払いへ進む',
    selectAmountFirst: '金額を選択してください',
    thankYou: 'ご支援ありがとうございます',
    footerNote: 'すべての寄付はゲーム開発とメンテナンスに使用されます',
    paymentMethod: '支払い方法',
    securePayment: '安全な Stripe 決済システム',
    supportCards: 'クレジットカード、デビットカード対応',
    instantProcess: '即時処理、安全で信頼性',
    poweredByStripe: 'Powered by Stripe - 安全な決済システム',
    paymentPageOpened: '決済ページが開きました。新しいウィンドウで支払いを完了してください。',
    benefits: {
      title: '支援者特典',
      benefit1: '私たちの永遠の感謝を受け取る',
      benefit2: 'ゲームの継続的な開発を支援',
      benefit3: '将来的に特別な報酬を受け取る可能性'
    }
  }
};